module.exports = require("os");